import WebFont from "webfontloader";
import { useEffect } from "react";

// Module-level cache to prevent duplicate font loads
const loadedFonts = new Set<string>();

export function useGoogleFont(fontFamily: string | null): string | null {
  useEffect(() => {
    if (!fontFamily || loadedFonts.has(fontFamily)) return;

    WebFont.load({
      google: { families: [fontFamily] },
      active: () => {
        loadedFonts.add(fontFamily);
      }
    });
  }, [fontFamily]);

  return fontFamily;
}
